import React, { useContext } from 'react'
import './style/v2-sidebar.scss'

import classnames from 'classnames'
import AppMenu from './app-menu'
import SidebarBottomMenu from './sidebar-bottom-menu'
import { IconPushly } from '../svg/icon-pushly'
import { AppState } from '../../stores/app'
import { AppService } from '../../services'
import { Container } from 'typescript-ioc/es5'
import { observer } from 'mobx-react'
import { PlatformUserContext } from '../../providers/user-provider/user-provider'
import { Button, Divider, Flex, Layout } from 'antd'
import { LeftOutlined } from '@ant-design/icons'
import { useUserPreferences } from '@pushly/aqe/lib/providers/user-preferences-provider/core/index'
import ActiveDomainSelector from './active-domain-selector'

const Sidebar: React.FC = observer(() => {
    const context = useContext(PlatformUserContext)
    const appState = Container.get(AppState)
    const appService = Container.get(AppService)
    const userPreferences = useUserPreferences(appState.currentUser?.id)

    const sidebarExpanded = userPreferences.get(['sidebar_expanded'])
    const { currentDomain } = appState

    const toggleSidebar = () => {
        userPreferences.set(['sidebar_expanded'], !sidebarExpanded)
    }

    if (!context.authenticated) return null

    return (
        <Layout.Sider
            width={200}
            collapsedWidth={64}
            collapsed={!sidebarExpanded}
            onCollapse={toggleSidebar}
            className={classnames('app-sidebar', appState.abilityStore.acs.state, {
                open: sidebarExpanded,
                collapsed: !sidebarExpanded,
                'context-org': appState.inOrgContext,
                'context-domain': appState.inDomainContext,
            })}
            collapsible
            trigger={null}
        >
            <Flex vertical justify="space-between" align="stretch" style={{ height: '100%' }}>
                <div>
                    <ActiveDomainSelector />
                    <Divider />
                    <AppMenu />
                </div>

                <div>
                    <Divider />
                    <SidebarBottomMenu />

                    <Divider />
                    <Flex
                        justify="center"
                        className="sidebar-logo"
                        onClick={() => {
                            if (currentDomain) {
                                appService.routeWithinDomain('/dashboard')
                            }
                        }}
                    >
                        <IconPushly />
                    </Flex>
                </div>
            </Flex>

            <div
                className={classnames('sidebar-toggle', {
                    open: sidebarExpanded,
                    collapsed: !sidebarExpanded,
                })}
                onClick={toggleSidebar}
            >
                <Button className="sidebar-toggle-btn" size="small" shape="circle" icon={<LeftOutlined />} />
            </div>
        </Layout.Sider>
    )
})

export default Sidebar
